module.exports = __webpack_public_path__ + "img/xingbie.b5c8fdf9.png";